import { pluralizeHours, pluralizeMinutes } from '@devhacker/shared/plugins/talker/utils/pluralize';

function padTo2Digits(num: number): string {
  return num.toString().padStart(2, '0');
}

export function getTimePassed(date: string): string {
  const MILLISECONDS_PER_MINUTE = 60000;

  // рассчет разницы между текущим временем и датой написания комментария
  const safariDateFormat = date.replace(/-/g, '/');
  const commentCreatedDate: Date = new Date(safariDateFormat);

  // расчет текущего времени в gmt
  const currentTime = new Date();

  // добавляем к дате коммента смещение с учетом локальной таймзоны
  // переделал формат даты под текущую в модуле talker (до рефакторинга)
  // чтобы даты/время комментариев в конце статьи соответствовали
  // в обычной версии и в амп
  // этот расчет также используется в виджете комментариев
  commentCreatedDate.setMinutes(commentCreatedDate.getMinutes() - currentTime.getTimezoneOffset());

  const minutes = Math.round(
    (currentTime.getTime() - commentCreatedDate.getTime()) / MILLISECONDS_PER_MINUTE,
  );
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const dateGMT = padTo2Digits(commentCreatedDate.getDate());
  const monthGMT = padTo2Digits(commentCreatedDate.getMonth() + 1);
  const yearGMT = commentCreatedDate.getFullYear().toString().slice(-2);
  const hoursGMT = padTo2Digits(commentCreatedDate.getHours());
  const minutesGMT = padTo2Digits(commentCreatedDate.getMinutes());

  if (days) {
    return days === 1 ? 'вчера' : `${dateGMT}.${monthGMT}.${yearGMT} ${hoursGMT}:${minutesGMT}`;
    // важно именно минуты сравнивать, а не часы
    // чтобы не было расхождений обычной и АМП версии
  } else if (minutes > 60) {
    return `${hours} ${pluralizeHours(hours)} назад`;
  } else if (minutes) {
    return `${minutes} ${pluralizeMinutes(minutes)} назад`;
  } else {
    return 'только что';
  }
}
